// Pad helper
const pad = (n) => String(n).padStart(2, '0');

/**
 * Given an instant (ISO/Z/etc.), return { date: 'YYYY-MM-DD', time: 'HH:mm' }
 * representing wall time in the target timezone (offsetMin minutes from UTC).
 * Uses UTC getters after shifting to avoid host TZ.
 */
export const toDateAndTimeInTZ = (dLike, offsetMin) => {
  if (!dLike) return { date: '', time: '' };
  const d = new Date(dLike);
  if (isNaN(d)) return { date: '', time: '' };
  const shifted = new Date(d.getTime() + offsetMin * 60000);
  return {
    date: `${shifted.getUTCFullYear()}-${pad(shifted.getUTCMonth() + 1)}-${pad(
      shifted.getUTCDate(),
    )}`,
    time: `${pad(shifted.getUTCHours())}:${pad(shifted.getUTCMinutes())}`,
  };
};

/**
 * Combine separate date ('YYYY-MM-DD') and time ('HH:mm') strings as *wall time*
 * in the given timezone offset, and produce RFC3339 with numeric offset,
 * e.g. '2025-09-03T12:30:00+07:00'. Returns null if missing/invalid.
 */
export const fromDateTimeToOffsetISO = (dateStr, timeStr, offsetMin) => {
  if (!dateStr || !timeStr) return null;
  const [y, m, d] = dateStr.split('-').map((x) => parseInt(x, 10));
  const [hh, mm] = timeStr.split(':').map((x) => parseInt(x, 10));
  if ([y, m, d, hh, mm].some((v) => Number.isNaN(v))) return null;

  const sign = offsetMin >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMin);
  const oh = pad(Math.floor(abs / 60));
  const om = pad(abs % 60);

  return `${y}-${pad(m)}-${pad(d)}T${pad(hh)}:${pad(mm)}:00${sign}${oh}:${om}`;
};

/**
 * Format an instant into "yyyy-MM-dd HH:mm:ss" as wall time in the target timezone.
 * Shift milliseconds, then read with UTC getters to avoid host TZ influence.
 */
export const formatInTZ = (dLike, offsetMin) => {
  if (!dLike) return '';
  const d = new Date(dLike);
  if (isNaN(d)) return '';
  const shifted = new Date(d.getTime() + offsetMin * 60000);
  return (
    `${shifted.getUTCFullYear()}-${pad(shifted.getUTCMonth() + 1)}-${pad(shifted.getUTCDate())} ` +
    `${pad(shifted.getUTCHours())}:${pad(shifted.getUTCMinutes())}:${pad(shifted.getUTCSeconds())}`
  );
};
